import axios from "axios";
import { Config } from "../config/Config";
import firebase from "../utilities/Firebase";

/**
 * 認証サービス
 */
export const AuthService = () => {
  /**
   * 認証
   * @param rawId 暗号化された認証情報
   * @returns 認証結果
   */
  const authentication = async (rawId: string) => {
    const response = await axios.post(
      Config.authFunc || "",
      { data: { data: decodeURIComponent(rawId) } },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    let result;
    if (response?.data) {
      // 認証に成功した場合、firebaseにサインインする
      // Firestore のユーザーを設定するため
      result = response.data.result;
      if (result) {
        await firebase.auth().signInWithCustomToken(result.apiToken);
      }
    }
    return result;
  };

  return { authentication };
};
